import React from 'react';

import cs from 'classnames';
import moment, {Moment} from 'moment-tz';

import {useCurrentUserState} from 'app/current-user/api';
import {SweetDatePicker} from 'app/general/widgets/SweetDatePicker';
import {gt} from 'app/utils/i18n';

interface Props {
  is_guest_until: string;
  onChange: (is_guest_until: string) => unknown;
  small?: boolean;
  inline?: boolean;
}

export function GuestAccessUntilField({
  is_guest_until,
  onChange,
  small = false,
  inline = true,
}: Props): JSX.Element {
  const {timezone} = useCurrentUserState().data!;

  return (
    <div className={cs('form-group align-items-center', {small, row: inline})}>
      <label
        className={cs('col-form-label font-weight-bold pr-0', {
          'col-sm-auto': inline,
        })}
      >
        {gt('Grant access until')}
      </label>
      <div className={cs({'col-sm': inline})}>
        <SweetDatePicker
          format="ll"
          options={{minDate: Date.now()}}
          className={cs('form-control', {'form-control-sm': small})}
          value={new Date(is_guest_until)}
          placeholder={gt('Expiry date')}
          disabled={false}
          onChange={(dates) =>
            onChange(getTimezonedDayEnd(moment(dates[0]), timezone))
          }
        />
      </div>
    </div>
  );
}

export function getTimezonedDayEnd(date: Moment, tz: string): string {
  // discard time info and keep day only, then convert to user tz and get end of day
  return moment(date.format('YYYY-MM-DD')).tz(tz).endOf('day').toISOString();
}
